<template>
    <div class="conversation-view">
        <div class="user-input-side">
            <div id="uiv_container"></div>
            <div class="stt-nav-button-container no-nlp">
                <img v-for="button in sttNavButtons" :id="button.id" class="stt-nav-button" @mouseover="doHoverState(button, 'hover')" @mouseout="doHoverState(button, '')" @click="handleClick(button)" :src="button.offFile" :style="doButtonPlacement(button)">
            </div>
        </div>
        <div class="convo-history-side">
            <ChatMessage
                v-for="(chatMsg, index) in chatLog"
                v-bind:key="index"
                v-bind:sender="chatMsg.sender"
                v-bind:isError="chatMsg.isError"
                v-bind:message="chatMsg.message" />
            <div class="no-nlp">
                <div id="stt-usr-name">{{ firstName }}:</div>
                <textarea name="noNlpAnswer" id="no-nlp-field" cols="18" rows="10" class="answer"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
    import ChatMessage from '@/components/ChatMessage.vue';

    export default {
        name: 'ConversationView',
        created: function() {
            var self = this;
            self.$root.$on('nlp-question', function(event) {
                if(event.isCallback) return;
                CodeBaby.jQuery('#no-nlp-field').val(event.question);
                
            });
            self.$root.$on('nlp-response', function(event) {
                if (self.chatLog.length > 0) self.chatLog.pop();
                self.chatLog.push({
                    sender: 'avatar',
                    message: event.answerText
                });
            });

            self.$root.$on('nlp-no_response', function(event) {
                /* 
                if (self.chatLog.length > 0) self.chatLog.pop();
                self.chatLog.push({
                    sender: 'avatar',
                    isError: true,
                    message: event.answerText
                });
                */
            });
        },
        watch: {
            chatLog: function(val, oldVal) {
                this.$nextTick(function() {
                    var histView = this.$el.querySelector('.convo-history-side');
                    histView.scrollTop = histView.scrollHeight;
                    CodeBaby.jQuery('.convo-history-side').scrollTop(0);
                });
            }
        },
        props: [
            "firstName"
        ],
        data: function() {
            return {
                chatLog: [],
                sttNavButtons: [
                    {
                        id: "stt-edit",
                        offFile: require('@/assets/images/stt-edit.png'),
                        hoverFile: require('@/assets/images/stt-edit-hover.png'),
                        xPos: 70,
                        yPos: 250
                    },
                    {
                        id: "stt-done",
                        offFile: require('@/assets/images/stt-done.png'),
                        hoverFile: require('@/assets/images/stt-done-hover.png'),
                        xPos: 147,
                        yPos: 250
                    }
                ]   
            }
        },
        components: {
            ChatMessage
        },
        methods: {
            doHoverState: function (buttonObj, state) {
                var newState = (state == 'hover') ? buttonObj.hoverFile : buttonObj.offFile;
                CodeBaby.jQuery("#" + buttonObj.id).attr({src: newState});
            },
            handleClick: function (buttonObj) {
                switch (buttonObj.id) {
                    case "stt-edit":
                        CodeBaby.jQuery("#no-nlp-field").focus();
                        break;
                    case "stt-done": 
                        CodeBaby.donePanel();
                        break;
                    default:
                        console.log('unrecognized button selected. See the handleClick method in ConversationView');
                }
            },
            doButtonPlacement: function(buttonObj) {
                return({position: "absolute", left: buttonObj.xPos + "px", top: buttonObj.yPos + "px"});
            }
        }
    }
</script>
<style lang="stylus">
    .conversation-view
        display: flex
        z-index 5001
        position: absolute
        top: 130px
        width: 270px
        height: 270px
        background: rgba(118, 172, 218, 0)
        border-radius: 5em
        padding: 0 1em
        color: #000
        box-sizing: border-box
        right: 100px
        .convo-history-side
            flex: 1
            overflow-x: hidden
            overflow-y: auto
            margin: 0.5em 1em 0.5em 0
            color: #4282ca
        .user-input-side
            position: relative
            width: 0
            #uiv_container
                position: relative
                bottom:0
                left:0
            .codebaby-stt-input
                display: none
            .codebaby-stt-button
                display: none
                position: relative
                font-size: 2em
                color: #fff
                border-radius: 100%
                background: #b5d16d
                padding: 8px 7px 8px 8px
                margin: -8px
                margin-left: 0
                top: 270px
                z-index: 6001
        #no-nlp-field
            background: none
            border: none
            font-size: 1em
            color:#8d2dac
        #stt-usr-name
            text-align: left
            color: #8d2dac
            font-size: 1em
            font-weight: bold
.finalStt
    color:#8d2dac
.nonFinalStt
    color:#bbbbbb
    
.stt-nav-button-container
    position: absolute
.no-nlp
    display: none
</style>